import { Button } from "devextreme-react";
import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import { PopupHeaderText } from "../typographyText/TypographyText";
import "./CustomSlider.scss";

export default function CustomSlider({
  isOpen,
  isSlidingOut,
  setSliderOpen,
  setIsSlidingOut,
  onClose,
  headtext,
  children,
}) {
  const [sliderClass, setSliderClass] = useState(isOpen ? "open" : "closed");

  useEffect(() => {
    if (isOpen) {
      setSliderClass("open");
    } else {
      setSliderClass("closed");
    }
  }, [isOpen, isSlidingOut]);

  useEffect(() => {
    if (isSlidingOut) {
      const timeoutId = setTimeout(() => {
        setSliderOpen(false); // Close the slider after the animation completes
        setIsSlidingOut(false); // Reset the sliding out state
      }, 0); // Match the slide-out animation duration
      return () => clearTimeout(timeoutId);
    }
  }, [isSlidingOut]);

  return ReactDOM.createPortal(
    <div className={`slider-overlay ${sliderClass}`}>
      <div className="slider-content">
        <div className="email-popup-header">
          <div className="email-text">
            <PopupHeaderText text={headtext} />
          </div>
          <div className="close-btn-section" onClick={onClose}>
            <Button icon="close" />
          </div>
        </div>
        {children}
      </div>
    </div>,
    document.body
  );
}
